// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyADjjRu4H5Djq_1bpX4H7muLVnl2j-fQqY",
    authDomain: "inclusive-family-insurance.firebaseapp.com",
    projectId: "inclusive-family-insurance",
    storageBucket: "inclusive-family-insurance.firebasestorage.app",
    messagingSenderId: "572616530607",
    appId: "1:572616530607:web:2efb834e482c9b3704925a",
    measurementId: "G-YNBMKRLGDC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
